import {
	HOVER_POI,
	LOAD_DISTRICT_DATA,
	LOAD_DISTRICT_DATA_BY_ID
} from "./constants";

const data = require("../../data/data.json");

export const loadDistrictData = () => {
	return {
		type: LOAD_DISTRICT_DATA,
		payload: data.A.district
	};
};

export const loadDistrictDataBuyId = id => {
	return {
		type: LOAD_DISTRICT_DATA_BY_ID,
		payload: id
	};
};

export const hoverPoi = id => {
	return {
		type: HOVER_POI,
		payload: id
	};
};
